import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import debounce from 'lodash.debounce';

import Svg from '../../../../../../../common/svgIcon';
import ErrorBanner from '../../../../../../../common/errorBanner';
import cleanStakeInput from '../../../../../../../common/utils/cleanStakeInput';
import { multiplesInfo } from '../../../../../../../common/utils/multiples';
import { ERROR_CODES, ERROR_MESSAGES } from '../../../../../../../common/utils/apiErrors';
import StakeField from '../../../../../../../common/stakeField';
import NumericKeypad from '../../../../../../../common/numericKeypad';
import FTRow from '../FTRow';
import './styles.scss';

const BANNER_DISPLAY_DELAY = 800;

const getNewStake = (rawStakeValue) => {
    const cleaned = parseFloat(cleanStakeInput(rawStakeValue))
    return (isNaN(cleaned)) ? 0 : cleaned
};

class FTSection extends Component {

    constructor(props) {
        super(props);

        this.renderOrderIcons = this.renderOrderIcons.bind(this);
        this.renderRowAsideContent = this.renderRowAsideContent.bind(this);
        this.renderRowIndexContent = this.renderRowIndexContent.bind(this);
    }

    onStakeUpdated = (rawStakeValue, targetId) => {
        this.dismissStakeErrors(rawStakeValue, targetId)
        this.displayStakeErrors({ rawStakeValue, targetId })
    }

    displayStakeErrors = debounce(({ rawStakeValue, targetId }) => {
        const {
            data,
            currencySign,
            setMultiplesError,
        } = this.props;
        const target = data.find(option => option.optionId === targetId);
        const {
            minStake,
            maxStake,
            optionId,
        } = target;

        if (rawStakeValue) {
            const newStake = getNewStake(rawStakeValue)

            if (minStake !== null && newStake < minStake) {
                const message = ERROR_MESSAGES.STAKE_TOO_LOW
                    .replace('%PRICE%', `${currencySign}${minStake.toFixed(2)}`)
                setMultiplesError(
                    optionId,
                    ERROR_CODES.STAKE_TOO_LOW,
                    message,
                )
            }

            if (maxStake !== null && newStake > maxStake) {
                const message = ERROR_MESSAGES.STAKE_TOO_HIGH
                    .replace('%PRICE%', `${currencySign}${maxStake.toFixed(2)}`)
                setMultiplesError(
                    optionId,
                    ERROR_CODES.STAKE_TOO_HIGH,
                    message,
                )
            }
        }
    }, BANNER_DISPLAY_DELAY)

    dismissStakeErrors = (rawStakeValue, targetId) => {
        const {
            data,
            clearMultiplesError,
        } = this.props;
        const target = data.find(option => option.optionId === targetId);
        const {
            error,
            minStake,
            maxStake,
            optionId,
        } = target;

        if (rawStakeValue) {
            const newStake = getNewStake(rawStakeValue)

            const shouldClearMinError =
                minStake !== null &&
                error.errorId === ERROR_CODES.STAKE_TOO_LOW &&
                newStake >= minStake

            const shouldClearMaxError =
                maxStake !== null &&
                error.errorId === ERROR_CODES.STAKE_TOO_HIGH &&
                newStake <= maxStake

            if (shouldClearMinError || shouldClearMaxError) {
                clearMultiplesError(optionId)
            }
        }
    }

    orderSelectionsClickHandler(optionIdsList, outcomersId, index) {
        optionIdsList.forEach(id => (
            this.props.changeSelectionOrder(id, outcomersId, index)
        ));
    }

    renderNumericKeyPad(option) {
        const {
            setIsEditingStake,
            setStake,
            isMobile,
        } = this.props;
        const {
            optionId,
            stakeValue,
            isEditingStake,
        } = option;

        return (isMobile && isEditingStake) ?
            (
                <NumericKeypad
                    targetId={optionId}
                    setIsEditingStake={setIsEditingStake}
                    setStake={setStake}
                    value={stakeValue}
                    maxLength={8}
                />
            ) :
            null;
    }

    renderOrderIcons(classBlock, index, lastRow, outcomersId) {
        if (lastRow) {
            return (
                <div className={`${classBlock}__aside-content`}>
                    <button
                        type="button"
                        className={
                            classNames(
                                `${classBlock}__order-button`,
                                `${classBlock}__order-button_up`,
                            )
                        }
                        onClick={() => {
                            this.orderSelectionsClickHandler(
                                this.props.optionIdsList,
                                outcomersId,
                                -1,
                            )
                        }}
                    >
                        <Svg
                            iconName="order-arrow"
                            size="Medium"
                            className={
                                classNames(
                                    `${classBlock}__order-arrow`,
                                    `${classBlock}__order-arrow_up`,
                                )
                            }
                        />
                    </button>
                </div>
            );
        }

        if (index === 0) {
            return (
                <div className={`${classBlock}__aside-content`}>
                    <button
                        type="button"
                        className={
                            classNames(
                                `${classBlock}__order-button`,
                                `${classBlock}__order-button_down`,
                            )
                        }
                        onClick={() => {
                            this.orderSelectionsClickHandler(
                                this.props.optionIdsList,
                                outcomersId,
                                1,
                            )
                        }}
                    >
                        <Svg
                            iconName="order-arrow"
                            size="Medium"
                            className={
                                classNames(
                                    `${classBlock}__order-arrow`,
                                    `${classBlock}__order-arrow_down`,
                                )
                            }
                        />
                    </button>
                </div>
            );
        }

        return (
            <div className={`${classBlock}__aside-content`}>
                <button
                    type="button"
                    className={
                        classNames(
                            `${classBlock}__order-button`,
                            `${classBlock}__order-button_up`,
                        )
                    }
                    onClick={() => {
                        this.orderSelectionsClickHandler(
                            this.props.optionIdsList,
                            outcomersId,
                            -1,
                        )
                    }}
                >
                    <Svg
                        iconName="order-arrow"
                        size="Medium"
                        className={
                            classNames(
                                `${classBlock}__order-arrow`,
                                `${classBlock}__order-arrow_up`,
                            )
                        }
                    />
                </button>
                <button
                    type="button"
                    className={
                        classNames(
                            `${classBlock}__order-button`,
                            `${classBlock}__order-button_down`,
                        )
                    }
                    onClick={() => {
                        this.orderSelectionsClickHandler(
                            this.props.optionIdsList,
                            outcomersId,
                            1,
                        )
                    }}
                >
                    <Svg
                        iconName="order-arrow"
                        size="Medium"
                        className={
                            classNames(
                                `${classBlock}__order-arrow`,
                                `${classBlock}__order-arrow_down`,
                            )
                        }
                    />
                </button>
            </div>
        );
    }

    renderRowIndexContent(
        classBlock,
        identifier,
        hasBetOrdering,
        index,
        raceTime,
        modalTitle,
        modalText,
    ) {
        switch (identifier) {
            case 'selection':
                if (index >= 0 && hasBetOrdering) {
                    const formattedIndex = index + 1;
                    let indexSuffix = 'th';
                    if (formattedIndex === 1) {
                        indexSuffix = 'st';
                    } else if (formattedIndex === 2) {
                        indexSuffix = 'nd';
                    } else if (formattedIndex === 3) {
                        indexSuffix = 'rd';
                    }
                    return (
                        <span className={`${classBlock}__index-content`}>
                            {formattedIndex}{indexSuffix}
                        </span>
                    );
                }

                return null;
            case 'heading':
                if (raceTime !== '') {
                    return (
                        <span className={`${classBlock}__index-content`}>
                            {raceTime}
                        </span>
                    );
                }

                return null;
            case 'option':
                return (
                    <button
                        type="button"
                        className={`${classBlock}__index-button`}
                        onClick={() => {
                            this.props.setGlobalModal({
                                title: modalTitle,
                                body: modalText,
                                ctaTitle: 'OK',
                            })
                        }}
                    >
                        <Svg
                            iconName="multiple-info"
                            size="Medium"
                            className={`${classBlock}__index-info-icon`}
                        />
                    </button>
                );
            default:
                return null;
        }
    }

    renderRowAsideContent(
        item,
        classBlock,
        identifier,
        hasBetOrdering,
        asideContent,
        index,
        lastRow,
        outcomersId,
    ) {
        switch (identifier) {
            case 'selection':
                if (hasBetOrdering) {
                    return this.renderOrderIcons(classBlock, index, lastRow, outcomersId);
                }

                return null;
            case 'heading':
                return (
                    <span className={`${classBlock}__aside-content`}>
                        {asideContent}
                    </span>
                );
            case 'option':
                return (
                    <div className={`${classBlock}__aside-content`}>
                        <StakeField
                            targetId={item.optionId}
                            currencySign={this.props.currencySign}
                            stakeValue={item.stakeValue}
                            setStake={this.props.setStake}
                            setIsEditingStake={this.props.setIsEditingStake}
                            isEditingStake={item.isEditingStake}
                            isMobile={this.props.isMobile}
                            onStakeUpdated={this.onStakeUpdated}
                            placeholder={item.numberLines > 1 ? 'Unit Stake' : 'Stake'}
                        />
                    </div>
                );
            default:
                return null;
        }
    }

    renderHeading(classBlock, identifier, hasBetOrdering, item, singleRow) {
        if (identifier === 'selections') {
            return (
                <div className={`${classBlock}__heading`}>
                    <FTRow
                        raceTime={item.raceTime}
                        identifier="heading"
                        textContent={item.courseName}
                        asideContent={singleRow || !hasBetOrdering ? '' : 'Change order'}
                        renderIndexContent={this.renderRowIndexContent}
                        renderAsideContent={this.renderRowAsideContent}
                    />
                </div>
            );
        }

        return null;
    }

    renderList(classBlock, identifier, hasBetOrdering, items, singleRow, isMobile) {
        if (items.length > 0) {
            if (singleRow) {
                return (
                    <div className={`${classBlock}__list-container`}>
                        <ul className={`${classBlock}__list`}>
                            <li
                                key={0}
                                className={`${classBlock}__list-item`}
                            >
                                <FTRow
                                    singleRow={singleRow}
                                    identifier={identifier}
                                    textContent={items.map(i => i.horseName).join(', ')}
                                />
                            </li>
                        </ul>
                    </div>
                );
            }

            return (
                <div className={`${classBlock}__list-container`}>
                    <ul className={`${classBlock}__list`}>
                        {items.map((item, index) => (
                            <li
                                key={item.optionId || item.outcomersId}
                                className={
                                    classNames(
                                        `${classBlock}__list-item`,
                                        `${identifier === 'option' && item.error.message !== null ?
                                            `${classBlock}__list-item_error` :
                                            ''
                                        }`,
                                        `${
                                            identifier === 'option' &&
                                            isMobile &&
                                            item.isEditingStake ?
                                            `${classBlock}__list-item_visible-keyboard` :
                                            ''
                                        }`,
                                    )
                                }
                            >
                                {identifier === 'option' && item.error.message !== null ?
                                    <ErrorBanner
                                        message={item.error.message}
                                        classBlockName={'bs-ft-errorBanner'}
                                    /> :
                                    ''
                                }
                                <FTRow
                                    index={index}
                                    item={item}
                                    lastRow={items.length === index + 1}
                                    singleRow={singleRow}
                                    hasBetOrdering={hasBetOrdering}
                                    modalTitle={
                                        identifier === 'option' ?
                                            multiplesInfo[item.betType].title :
                                            ''
                                    }
                                    modalText={
                                        identifier === 'option' ?
                                            multiplesInfo[item.betType].body :
                                            ''
                                    }
                                    identifier={identifier}
                                    textContent={
                                        identifier === 'selection' ?
                                            item.horseName :
                                            `${multiplesInfo[item.betType].formTitle} 
                                            (x${item.numberLines})`
                                    }
                                    outcomersId={
                                        identifier === 'selection' ?
                                            item.outcomersId :
                                            ''
                                    }
                                    renderIndexContent={this.renderRowIndexContent}
                                    renderAsideContent={this.renderRowAsideContent}
                                />
                                {identifier === 'option' ?
                                    this.renderNumericKeyPad(item) :
                                    null
                                }
                            </li>
                        ))}
                    </ul>
                </div>
            );
        }

        return null;
    }

    render() {
        const {
            classBlockName,
            classBlockAddon,
            data,
            hasBetOrdering,
            isMobile,
        } = this.props;
        const classBlock = `${classBlockName}-${classBlockAddon}`;
        const listItemIdentifier = classBlockAddon.slice(0, -1);
        const singleRow = classBlockAddon === 'selections' && data.length > 3;

        return (
            <div className={`${classBlock}`}>
                {this.renderHeading(
                    classBlock,
                    classBlockAddon,
                    hasBetOrdering,
                    data[0],
                    singleRow,
                )}
                {this.renderList(
                    classBlock,
                    listItemIdentifier,
                    hasBetOrdering,
                    data,
                    singleRow,
                    isMobile,
                )}
            </div>
        );
    }
}

FTSection.defaultProps = {
    classBlockName: 'bs-ft-section',
    classBlockAddon: 'selections',
    data: [],
    optionIdsList: [],
    hasBetOrdering: true,
    isMobile: false,
    currencySign: '£',
    setStake: () => {},
    setIsEditingStake: () => {},
    changeSelectionOrder: () => {},
};

FTSection.propTypes = {
    classBlockName: PropTypes.string,
    classBlockAddon: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(
        PropTypes.shape(),
    ).isRequired,
    optionIdsList: PropTypes.arrayOf(
        PropTypes.string,
    ).isRequired,
    hasBetOrdering: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    currencySign: PropTypes.string.isRequired,
    setStake: PropTypes.func.isRequired,
    setMultiplesError: PropTypes.func.isRequired,
    clearMultiplesError: PropTypes.func.isRequired,
    changeSelectionOrder: PropTypes.func.isRequired,
    setIsEditingStake: PropTypes.func.isRequired,
    setGlobalModal: PropTypes.func.isRequired,
};

export default FTSection;



// WEBPACK FOOTER //
// /src/js/drawer/components/BetPage/components/FTForm/components/FTSection/FTSection.jsx